import IconContainer from '@/components/IconContainer'

export default function IconColorConfirm(props) {
  return (
    <IconContainer {...props} width="28" height="28" ariaLabel="Confirm Icon">
      <circle cx="14" cy="14" r="10" fill="#01B292" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8128 10.5744C19.0103 10.8397 18.9846 11.24 18.7554 11.4686L12.7148 17.4921C12.5042 17.7022 12.191 17.6962 11.9864 17.4784L9.21841 14.5307C8.99577 14.2936 8.98133 13.8925 9.18616 13.6347C9.39099 13.377 9.73753 13.3603 9.96017 13.5974L12.3693 16.1629L18.0403 10.5078C18.2695 10.2793 18.6154 10.309 18.8128 10.5744Z"
        fill="white"
      />
    </IconContainer>
  )
}
